import { z } from 'zod';
import { DataSyncUnsuppliedReasonSchema } from '../../shared/data-sync';
import { BulkAddDepartmentInputSchema } from '../initialize-add-departments/initialize-add-departments.schema';
import { UserInputSchema } from '../initialize-add-users/initialize-add-users.schema';
import { InitializeMembershipInputSchema, InitializeOrgFunctionInputSchema } from '../initialize-add-org-functions/initialize-add-org-functions.schema';
/**
 * A supervisor-based manager suggestion for a department without a lead:
 * shown in Manager auflösen on the department of that name, never pre-filled.
 */ export const DataSyncManagerSuggestionSchema = z.object({
    departmentName: z.string(),
    userEmail: z.string(),
    displayName: z.string()
});
/** A present person the setup cannot take: listed under the Mitarbeiter table, not a row. */ export const PersonioSetupUnsuppliedPersonSchema = z.object({
    firstName: z.string(),
    lastName: z.string(),
    email: z.string().nullable(),
    reasons: z.array(DataSyncUnsuppliedReasonSchema)
});
/** GET /api/v2/data-sync/personio/setup-rows: the initial-setup tables, seeded from the stored snapshot. */ export const ShowPersonioSetupRowsResponseSchema = z.object({
    departments: z.array(BulkAddDepartmentInputSchema),
    users: z.array(UserInputSchema),
    teams: z.array(InitializeOrgFunctionInputSchema),
    memberships: z.array(InitializeMembershipInputSchema),
    managerSuggestions: z.array(DataSyncManagerSuggestionSchema),
    unsupplied: z.array(PersonioSetupUnsuppliedPersonSchema)
});

//# sourceMappingURL=show-personio-setup-rows.schema.js.map